import React, { Fragment, useState, forwardRef, useImperativeHandle } from 'react';
import './index.scss';
import ViewSDKClient from '../../../components/adobe-dc/ViewSDKClient';
import orderApi from '../../../api/order';
import credentials from '../../../utils/credentials';
const PackingSlip = forwardRef((props, ref) => {
    const [orderID, setOrderID] = useState();
    const PreviewPackingSlipOnClick = (orderId) => {
        orderApi.fetchPackingSlips(orderId).then(res => {
            const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
            var url = window.URL.createObjectURL(pdfBlob);

            const viewSDKClient = new ViewSDKClient();
            viewSDKClient.ready().then(() => {
                viewSDKClient.previewFile(credentials.adobe_api_key, "pdf-div", "LIGHT_BOX", url, "Preview");
            });
        })
    }
    useImperativeHandle(ref, (e) => ({ PreviewPackingSlipOnClick }));
    return (
        <Fragment>
            <div id="pdf-div" className={'content-block'} />
        </Fragment>
    )
})

export default PackingSlip;